// modal.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalState = new BehaviorSubject<{isOpen: boolean, type: string, action: string, data: any}>({
    isOpen: false,
    type: '',
    action: '',
    data: null
  });

  getModalState(): Observable<any> {
    return this.modalState.asObservable();
  }

  openModal(type: string, action: string, data: any = null) {
    this.modalState.next({
      isOpen: true,
      type,
      action,
      data
    });
  }
// In your modal.service.ts, add a specific method for address:
openAddressModal(action: string, data: any = null) {
  this.modalState.next({
    isOpen: true,
    type: 'address',
    action: action,
    data: data
  });
}
  closeModal() {
    this.modalState.next({
      isOpen: false,
      type: '',
      action: '',
      data: null
    });
  }
}